import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import type { UmamiProviderType } from './UmamiProvider.types';

const UmamiProvider = ({ url, id, enabled }: UmamiProviderType) => {
  const [currentlyEnabled, setCurrentlyEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (enabled !== currentlyEnabled) {
      setCurrentlyEnabled(enabled === true);
    }
  }, [enabled, currentlyEnabled]);

  return currentlyEnabled ? (
    <Helmet>
      <script defer src={`https://${url}/script.js`} data-website-id={id} />
    </Helmet>
  ) : null;
};

export default UmamiProvider;
